// extracted by mini-css-extract-plugin
export default {"page":"Pages_page__Dagj0","base":"Pages_base__tzyFR","header":"Pages_header__MBZfJ","controls":"Pages_controls__0dZ4J","buttons":"Pages_buttons__Wh1bp"};